<!--
 * @Author: Vben
 * @Description: logo component
-->
<template>
  <div
    class="anticon"
    :class="[getAppLogoClass, [!getCollapsed ? 'justify-between' : 'justify-center']]"
  >
    <div v-if="showBasicAILogo" class="wrapper">
      <div>
        <img class="logo" :src="showLogo" @click="goHome" />
      </div>
      <div
        class="title ml-2 truncate md:opacity-100 title-text"
        :class="getTitleClass"
        v-show="showTitle && !getCollapsed"
      >
        {{ title }}
      </div>
    </div>
    <div v-if="!getCollapsed" @click="handleColl" class="w-24px h-24px cursor-pointer">
      <img style="width: 24px; height: 24px" :src="backIcon" alt="" />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import { useGo } from '/@/hooks/web/usePage';
  import { useMenuSetting } from '/@/hooks/setting/useMenuSetting';
  import { useDesign } from '/@/hooks/web/useDesign';
  import backIcon from '/@/assets/images/backIcon.png';
  // import Icon from '/@/components/Icon';
  import { useUserStore } from '/@/store/modules/user';
  import logo from '/@/assets/images/logo.svg';
  import logoMini from '/@/assets/images/logo-mini.svg';
  import logoChina from '/@/assets/images/logo-CHINA.svg';
  import logoMiniChina from '/@/assets/images/logo-mini-CHINA.svg';
  import { AppMode } from '/@/api/sys/model/userModel';
  import { RouteEnum } from '/@/enums/routeEnum';

  const userStore = useUserStore();
  const showBasicAILogo = computed(() => {
    return !userStore.getGlobalConfig?.hideLogo;
  });

  const isChina = computed(() => {
    return userStore.getGlobalConfig?.runningMode === AppMode.China;
  });

  const props = defineProps({
    /**
     * The theme of the current parent component
     */
    theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
    /**
     * Wasync hether to show title
     */
    showTitle: { type: Boolean, default: true },
    /**
     * The title is also displayed when the menu is collapsed
     */
    alwaysShowTitle: { type: Boolean },
  });

  const { prefixCls } = useDesign('app-logo');
  const { getCollapsedShowTitle, getCollapsed, setMenuSetting } = useMenuSetting();
  // const userStore = useUserStore();

  const showLogo = computed(() => {
    // return logoMini;

    if (!getCollapsed.value) {
      return isChina.value ? logoChina : logo;
    } else {
      return isChina.value ? logoMiniChina : logoMini;
    }
  });
  const title = computed(() => {
    return '';
  });

  const go = useGo();

  const getAppLogoClass = computed(() => [
    prefixCls,
    props.theme,
    { 'collapsed-show-title': unref(getCollapsedShowTitle) },
  ]);

  const getTitleClass = computed(() => [
    `${prefixCls}__title`,
    {
      'xs:opacity-0': !props.alwaysShowTitle,
    },
  ]);

  const handleColl = () => {
    setMenuSetting({ collapsed: true });
  };

  function goHome() {
    go(RouteEnum.RECENTS);
  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    display: flex;
    padding: 0 16px;
    // justify-content: space-between;
    align-items: center;
    transition: all 0.2s ease;

    .wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;

      .logo {
        width: unset;
        height: unset;
      }

      .title {
        overflow: hidden;
        max-width: 100px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    // &.light {
    //   border-bottom: 1px solid @border-color-base;
    // }

    &.collapsed-show-title {
      padding-left: 20px;
    }

    &.light &__title {
      color: @primary-color;
    }

    &.dark &__title {
      color: @white;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      transition: all 0.5s;
      line-height: normal;
    }
  }
</style>
